import { KALIBRASYON_UYARI_KALIPLARI } from "./kalibrasyon.js";
import { NDT_UYARI_KALIPLARI } from "./ndt-raporu.js";
// M3-6: `yes` / `no` okuması PWHT grafiğininkiyle aynıdır (büyük-küçük harfe duyarsız; öteki her yazım null).
import { evetHayir } from "./pwht-grafigi.js";
import { kimlikSade } from "./sarf.js";
import { TESLIM_OKUMA_DEGISTI_METNI, TESLIM_UYARI_KALIPLARI } from "./teslim-listesi.js";
import { WPS_BELGESI_UYARI_KALIPLARI } from "./wps-belgesi.js";
/** Dönüşüm işinin belge türü (`donusum_isi.belge_turu`). */
export const MALZEME_BELGE_TURU = "malzeme_sertifikasi";
/** Okunan Documents türleri (GELEN_TURLERI anahtarları; Registers grubu, kütük sınıfı). Yeni Documents türü yoktur (M3-1). */
export const MALZEME_GELEN_TURLERI = ["kutuk:stok_paket:en10204_31", "kutuk:stok_paket:en10204_32"];
export const malzemeGelenTuruMu = (t) => MALZEME_GELEN_TURLERI.includes(t ?? "");
export const malzemeSatirTuru = (t) => malzemeGelenTuruMu(t) ? t.slice("kutuk:stok_paket:".length) : null;
/** Olay kaydında nesne tipi (nesneId = malzeme_sertifikasi_kaydi.id). */
export const MALZEME_OLAY_NESNESI = "malzeme_sertifikasi_kaydi";
/** Okunan hafif excel'in belge ailesi. Hiçbir aile sorgusu bu adı almaz (Riser Documentation, kanıt zinciri ve aile işlemleri). */
export const MALZEME_GIRDI_AILESI = "Material-certificate-input";
/** DOCUMENT sayfasındaki "Document type" değeri. */
export const MALZEME_EXCEL_ADI = "Material certificate";
/** Okuma işi kodu ("MTC-5A1B2C3D"); "MTL-" uyarı kodlarından ve belgelerdeki değirmen no'larından ayrı. */
export const malzemeKodu = (kayitId) => `MTC-${kayitId.replace(/-/g, "").slice(0, 8).toUpperCase()}`;
/** Bir dosyada en çok sertifika, sertifikada en çok heat ve sonuç satırı, kitapta en çok indeks satırı. */
export const MALZEME_SERTIFIKA_EN_COK = 60;
export const MALZEME_HEAT_EN_COK = 20;
export const MALZEME_SONUC_EN_COK = 40;
export const MALZEME_INDEKS_EN_COK = 200;
/**
 * DOCUMENT alanları (5; sabit sıra; sözleşme §13.3, sürüm 1). Her alanın tüketicisi sözleşmede ve `malzeme-karsilastirma.ts`'te (`MALZEME_OKUNAN`) yazılıdır. `etiket` hem ekran
 * metni hem excel'deki Field adıdır.
 */
export const MALZEME_ALANLARI = [
    { alan: "kapak_mrb", etiket: "Cover: manufacturing record book", kimlik: false },
    { alan: "kapak_yedek", etiket: "Cover: riser spares", kimlik: false },
    { alan: "kapak_tag", etiket: "Cover: TAG", kimlik: false },
    { alan: "kapak_overhauled", etiket: "Cover: overhauled", kimlik: false },
    { alan: "musteri_po", etiket: "Customer PO", kimlik: false },
];
/** Sertifika düzeyi alanlar (ROWS, `Line` boş; sertifika başına 5). Kimlik: PN, sertifika no, lot anahtarı. */
export const MALZEME_SERTIFIKA_ALANLARI = [
    { alan: "pn", etiket: "Part number", kimlik: true },
    { alan: "sertifika_turu", etiket: "Certificate type", kimlik: false },
    { alan: "tanik", etiket: "Witness signature", kimlik: false },
    { alan: "sertifika_no", etiket: "Certificate number", kimlik: true },
    { alan: "lot_anahtari", etiket: "Lot key", kimlik: true },
];
/** Heat satırı alanları (ROWS, `Line` H1…H20; satır başına 5). Kimlik: basılı heat, el yazısı heat, değirmen lotu. */
export const MALZEME_HEAT_ALANLARI = [
    { alan: "heat", etiket: "Heat", kimlik: true },
    { alan: "heat_el", etiket: "Handwritten heat", kimlik: true },
    { alan: "degirmen_lotu", etiket: "Mill lot", kimlik: true },
    { alan: "miktar", etiket: "Quantity", kimlik: false },
    { alan: "birim", etiket: "Unit", kimlik: false },
];
/** Sonuç satırı alanları (ROWS, `Line` R1…R40; yalnız sınırı basılı satır; satır başına 4). */
export const MALZEME_SONUC_ALANLARI = [
    { alan: "ozellik", etiket: "Property", kimlik: false },
    { alan: "sonuc", etiket: "Result", kimlik: false },
    { alan: "alt_sinir", etiket: "Lower limit", kimlik: false },
    { alan: "ust_sinir", etiket: "Upper limit", kimlik: false },
];
/** İndeks satırı alanları (yalnız kitap; ROWS, `Certificate` boş, `Line` I1…I200; satır başına 2). */
export const MALZEME_INDEKS_ALANLARI = [
    { alan: "pn", etiket: "Part number", kimlik: true },
    { alan: "indeks_sayfalari", etiket: "Index pages", kimlik: false },
];
/** Alanın ekran adı (beş listede aranır); bilinmiyorsa alanın kendisi. */
export const malzemeEtiketi = (alan) => [...MALZEME_ALANLARI, ...MALZEME_SERTIFIKA_ALANLARI, ...MALZEME_HEAT_ALANLARI, ...MALZEME_SONUC_ALANLARI, ...MALZEME_INDEKS_ALANLARI]
    .find((a) => a.alan === alan)?.etiket ?? alan;
/** ROWS başlığı (uzun biçim; `Certificate` sertifikanın sırası, `Pages` aralığı, `Line` boş · H · R · I). */
export const MALZEME_SATIR_BASLIKLARI = ["Certificate", "Pages", "Line", "Field", "Value", "As written", "Page", "Certainty"];
/** Kişinin onaylarının alanları (`belge_deger_onayi.alan`; sertifikanın parçasında). */
export const MALZEME_EKLEME_ALANI = "kutuk_satiri";
export const MALZEME_HEAT_KAYIT_ALANI = "paket_heat";
export const MALZEME_PO_KAYIT_ALANI = "paket_po";
/** M3-19: çok sertifikalı okunmuş dosyada formun Pages'i Record'daki paketin sertifikalarından birinin aralığı değilse dosyalama kapısının cümlesi (409). */
export const MALZEME_SAYFA_METNI = "Pages do not match a certificate of this stock package. Use the pages of the certificate (“Use these pages”), or leave Pages empty.";
/** `Certificate type` hücresinin değerleri (yalnız bunlar ya da boş). */
export const MALZEME_SERTIFIKA_TURLERI = ["3.1", "3.2", "2.2", "2.1", "other"];
/* ---------------- değer biçimleri (yalnız kesin değerler kullanılır) ---------------- */
/** M3-6: `Certificate type` değeri (listedeki yazım, büyük-küçük harfe duyarsız); öteki her yazım null. */
export function sertifikaTuruOku(v) {
    const s = (v ?? "").trim().toLowerCase();
    return MALZEME_SERTIFIKA_TURLERI.find((x) => x === s) ?? null;
}
const SINIR = /^-?\d{1,7}([.,]\d{1,4})?$/;
/** M3-6: `Result`, `Lower limit`, `Upper limit` değeri (ondalık `,` ya da `.`); biçim dışı null. */
export function sinirSayisi(v) {
    const s = (v ?? "").trim();
    return SINIR.test(s) ? Number(s.replace(",", ".")) : null;
}
/** M3-6: `Index pages` ve sertifika `Pages` değeri ("N" ya da "N-M"); biçim dışı ya da ters aralık null. */
export function sayfaAraligiOku(v) {
    const m = /^(\d+)(?:\s*-\s*(\d+))?$/.exec((v ?? "").trim());
    if (!m)
        return null;
    const bas = Number(m[1]);
    const son = Number(m[2] ?? m[1]);
    return bas >= 1 && son >= bas ? { bas, son } : null;
}
/** Aralığın metni ("3" ya da "97-100"). */
export const malzemeAralikMetni = (s) => (s.bas === s.son ? String(s.bas) : `${s.bas}-${s.son}`);
const degerOf = (l, alan) => (l ?? []).find((x) => x.alan === alan) ?? null;
/** Kesin ve dolu değerin kırpılmış metni; değilse null. */
export const malzemeKesin = (l, alan) => {
    const d = degerOf(l, alan);
    return d && d.kesinlik === "kesin" && d.deger !== null && d.deger.trim() ? d.deger.trim() : null;
};
/**
 * M3-5 (saf): kapak işaretlerinden dosyanın cinsi (ilk tutan; yalnız kesin değerler): TAG ya da Overhauled yes → datapack; MRB başlığı no → tek; MRB yes ve RISER SPARES yes →
 * kitap; MRB yes, RISER SPARES no, TAG ve Overhauled no → OEM MRB; aksi belirsiz.
 */
export function malzemeDosyaCinsi(degerler) {
    const e = (alan) => evetHayir(malzemeKesin(degerler, alan));
    const tag = e("kapak_tag");
    const ovh = e("kapak_overhauled");
    const mrb = e("kapak_mrb");
    const yedek = e("kapak_yedek");
    if (tag === true || ovh === true)
        return "datapack";
    if (mrb === false)
        return "tek";
    if (mrb === true && yedek === true)
        return "kitap";
    if (mrb === true && yedek === false && tag === false && ovh === false)
        return "oem_mrb";
    return "belirsiz";
}
/**
 * M3-7 (saf): tür önerisi. 3.1 → en10204_31; 3.2 ve tanık imzası kesin yes → en10204_32; 3.2 ve tanık kesin no → en10204_31 (not `tanik_yok`); 3.2 ve tanık kesin değil → null
 * (not `suphe`); 2.1, 2.2, other ve boş → null. `tanik`: kesin değer (`evetHayir`), kesin değilse null.
 */
export function malzemeTurOnerisi(tur, tanik) {
    if (tur === "3.1")
        return { oneri: "en10204_31", not: null };
    if (tur === "3.2") {
        if (tanik === true)
            return { oneri: "en10204_32", not: null };
        if (tanik === false)
            return { oneri: "en10204_31", not: "tanik_yok" };
        return { oneri: null, not: "suphe" };
    }
    return { oneri: null, not: null };
}
/** M3-9: sertifikanın kimlikleri: kesin basılı heat, el yazısı heat ve değirmen lotu (bütün H satırları) ve kesin lot anahtarı; `kimlikSade`, tekil, en az 3 karakter. */
export function malzemeKimlikleri(s) {
    const l = [];
    for (const h of s.heatler ?? [])
        for (const a of ["heat", "heat_el", "degirmen_lotu"]) {
            const v = malzemeKesin(h.degerler, a);
            if (v)
                l.push(kimlikSade(v));
        }
    const anahtar = malzemeKesin(s.degerler, "lot_anahtari");
    if (anahtar)
        l.push(kimlikSade(anahtar));
    return [...new Set(l.filter((x) => x.length >= 3))];
}
/**
 * M3-9: sınırlı içerme. Kimlik en az 5 karakter ve paketin "heat / lot / SN" metninin (`kimlikSade`) içinde, geçtiği yerlerden en az birinde hemen önceki ve hemen sonraki
 * karakter rakam değil ("HEAT 9990003011" ve "PO 999101-0001" içerir; "99900030112" içermez).
 */
export function izIceriyor(iz, kimlik) {
    const k = kimlikSade(kimlik);
    const m = kimlikSade(iz);
    if (k.length < 5 || !m)
        return false;
    for (let i = m.indexOf(k); i >= 0; i = m.indexOf(k, i + 1)) {
        const once = i > 0 ? m[i - 1] : "";
        const sonra = m[i + k.length] ?? "";
        if (!/\d/.test(once) && !/\d/.test(sonra))
            return true;
    }
    return false;
}
/** M3-16: lot anahtarının ve PO'nun karşılaştırma anahtarı: `kimlikSade`, harf-rakam dışı atılır, baştaki `PO` ya da `LOT` öneki (ardından rakam geliyorsa) atılır. */
export function anahtarSade(v) {
    return kimlikSade(v).replace(/[^A-Z0-9]/g, "").replace(/^(?:PO|LOT)(?=\d)/, "");
}
/** M3-13 (c): dosya adının heat'e benzeyen parçaları: harf-rakam dizileri, en az 6 karakter ve en az 5 rakam, büyük harf. */
export function dosyaAdiParcalari(ad) {
    return [...new Set((ad ?? "").match(/[A-Za-z0-9]+/g) ?? [])].filter((x) => x.length >= 6 && (x.match(/\d/g) ?? []).length >= 5).map((x) => x.toUpperCase());
}
/** M3-13 (c): aynı uzunluktaki iki metnin farklı karakter sayısı; uzunluk farklıysa null. */
export function karakterFarki(a, b) {
    if (a.length !== b.length)
        return null;
    let n = 0;
    for (let i = 0; i < a.length; i++)
        if (a[i] !== b[i])
            n++;
    return n;
}
/** M3-17: sonuç basılı sınırın dışında mı ("alt" | "ust"); sınır yoksa ya da içerideyse null. */
export function sonucDisinda(sonuc, alt, ust) {
    if (alt !== null && sonuc < alt)
        return "alt";
    if (ust !== null && sonuc > ust)
        return "ust";
    return null;
}
/* ---------------- uyarılar ---------------- */
/**
 * Kartta üretilen kodlar (sertifika uyarıları bu sırayla; parçasızlar GEN-04 (kapak) ve GEN-09). Hiçbiri KAPALI_UYARI_KODLARI'nda olamaz (test). MTL-05, MTL-07 ve GEN-06 kapalıdır;
 * TES-01, TES-02, TES-04, TES-05, GEN-02, GEN-10, GEN-12, GEN-13, GEN-15, GEN-17, GEN-19 ve GEN-20 bu kartta üretilmez.
 */
export const MALZEME_UYARI_KODLARI = ["MTL-01", "MTL-06", "MTL-03", "MTL-04", "MTL-09", "TES-03", "MTL-02", "GEN-11", "GEN-04", "MTL-08", "GEN-09"];
/**
 * Uyarı kalıpları (İngilizce anahtar; Türkçesi sözlükte). MTL-01 ve MTL-08'in varyantları planın kalıbının yazılmış hâlidir (kod aynı). TES-03, GEN-11, GEN-04 ve GEN-09 öteki
 * okuyucularınkiyle aynıdır.
 */
export const MALZEME_UYARI_KALIPLARI = {
    mtl01Paket: "Heat differs: certificate {0}, stock package {1} {2}.",
    mtl01El: "Heat differs: certificate {0}, handwritten mark {1}.",
    mtl01Dosya: "Heat differs: certificate {0}, file name {1}.",
    mtl02: "Several heats on one certificate. Choose the heat for each stock package.",
    mtl03: "Stock packages exceed the certificate quantity: {0} / {1}.",
    mtl04: "Lot key {0} does not match the packing list lot {1}.",
    mtl06: "Result outside the limit on the certificate: {0}.",
    mtl08Sayfa: "Book index differs from the certificate: {0} is on p.{1} in the index, the certificate is on p.{2}.",
    mtl08Yok: "Book index differs from the certificate: {0} is not in the index.",
    mtl09: "Product arrived without heat or PO. Values proposed from the certificate.",
    tes03: TESLIM_UYARI_KALIPLARI["TES-03"],
    gen11: WPS_BELGESI_UYARI_KALIPLARI["GEN-11"],
    gen04: KALIBRASYON_UYARI_KALIPLARI["GEN-04"],
    gen09: NDT_UYARI_KALIPLARI["GEN-09"],
};
/** Saf (M3-20): kartın durumu ve yazımın ön denetimi aynı kuraldır; ilk tutan döner. `engel` yalnız "engel" durumunda dolu. */
export function malzemeEklemeEngeli(d) {
    const ol = (durum, engel = null) => ({ durum, engel });
    if (d.kapali)
        return ol("kapali");
    if (!d.yerVar)
        return ol("yer_yok");
    if (d.pakette)
        return ol("pakette");
    if (d.acik)
        return ol("dosyalanmadi");
    if (!d.turVar)
        return ol("tur_yok");
    if (!d.okumaGuncel)
        return ol("engel", TESLIM_OKUMA_DEGISTI_METNI);
    if (d.engel)
        return ol("engel", d.engel);
    return ol("eklenebilir");
}
/** Kayıtlı değer bir adayı taşıyor mu (heat / lot / SN'in bir parçası ya da tamamı; `kimlikSade`). */
const kayittaMi = (kayitli, adaylar) => {
    const parcalar = [kimlikSade(kayitli), ...kayitli.split(/[,;\n]/).map((x) => kimlikSade(x))].filter(Boolean);
    return adaylar.some((a) => parcalar.includes(kimlikSade(a)));
};
/** Saf (M3-22): kartın durumu ve yazımın ön denetimi aynı kuraldır; ilk tutan döner. `engel` yalnız "engel" durumunda dolu. */
export function malzemeKayitEngeli(d) {
    const ol = (durum, engel = null) => ({ durum, engel });
    if (!d.dosyalandi)
        return ol("dosyalanmadi");
    if (d.onay)
        return ol("kaydedildi");
    const kayitli = d.kayitli?.trim() ? d.kayitli.trim() : null;
    if (kayitli !== null)
        return ol(kayittaMi(kayitli, d.adaylar) ? "kayitta" : "farkli");
    if (!d.adaylar.length)
        return ol("kesin_degil");
    if (!d.okumaGuncel)
        return ol("engel", TESLIM_OKUMA_DEGISTI_METNI);
    if (d.engel)
        return ol("engel", d.engel);
    return ol("yazilabilir");
}
//# sourceMappingURL=malzeme-sertifikasi.js.map